import {atom} from "jotai";
import {DATE_FORMAT_DATE} from "../../constants";

export const dateFormatAtom = atom(DATE_FORMAT_DATE);